// extracted by mini-css-extract-plugin
export default {"container":"eK-z","dimension":"fK-z","dimensionLabels":"gK-z"};